import { CountUp } from 'countup.js';

document.querySelectorAll('.js-fact').forEach(($el) => {
  const $value = $el.querySelector('.js-fact-value');
  if (!$value) return;

  const a11yValue = $value.textContent.trim();

  if (a11yValue !== '' && !$el.querySelector('.js-fact-value-a11y')) {
    const $a11yValue = document.createElement('span');
    $a11yValue.className = 'u-hidden-visually js-fact-value-a11y';
    $a11yValue.textContent = a11yValue;
    $value.setAttribute('aria-hidden', 'true');
    $value.insertAdjacentElement('afterend', $a11yValue);
  }

  const endVal = parseInt($value.dataset.countValue, 10) || 0;
  const suffix = $value.dataset.countSuffix || '';
  const prefix = $value.dataset.countPrefix || '';
  const separator = $value.dataset.countSeparator || '.';
  const decimalPlaces = parseInt($value.dataset.countDecimalPlaces, 10) || 0;
  const duration = parseFloat($value.dataset.countDuration) || 2;

  const countUp = new CountUp($value, endVal, {
    duration,
    separator,
    decimal: ',',
    decimalPlaces,
    suffix,
    prefix,
    useGrouping: separator !== '',
    autoAnimate: true,
    autoAnimateOnce: true,
  });

  if (countUp.error) {
    console.error('CountUp error:', countUp.error);
  }
});
